export default "__VITE_ASSET__CPqtM11W__"